import { Component, OnInit } from '@angular/core';
import { VisaoLeadsServiceService } from './visao-leads-service/visao-leads.service';
import { StatusContatoAtivo } from './interfaces/status-contato-ativo';
import { LeadInsucesso, LeadSummary } from './interfaces/lead-summary';
import { InsucessosQualificados } from './interfaces/insucessos-qualificados';
import { FunilConversao } from './interfaces/funil-conversao';
import { FiltroDealers } from './filtro-dealer';
import { FiltroService } from '../../../shared/filtro/filtro.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import moment from 'moment';
import { PrimeiroContato } from './interfaces/primeiro-contato';
import { DealerItem } from '../../../shared/filtro-dealers/filtro-dealers.component';
import { Regional } from '../../businness-intelligence/fluxo-leads/fluxo-leads.model';

@Component({
  selector: 'app-visao-leads',
  templateUrl: './visao-leads.component.html',
  styleUrls: ['./visao-leads.component.css']
})
export class VisaoLeadsComponent implements OnInit {

  form: FormGroup;
  filtros: any;
  dataFinal: Date = new Date();
  dataInicial: Date = new Date(this.dataFinal.getFullYear(), this.dataFinal.getMonth(), 1);
  statusContatoAtivo: StatusContatoAtivo;
  optionsStatusContatoAtivo: any;
  leadData: LeadSummary;
  insucessoLeads: LeadInsucesso;
  totalInsucesso: number = 0;
  insucesso: InsucessosQualificados;
  primeiroContato: PrimeiroContato;
  funilConversao: FunilConversao;
  servico: VisaoLeadsServiceService;
  filtrosDealers: any;
  regionais: Regional[] = [];
  displayFiltrosDealers: boolean = false;
  displayFiltros: boolean = false;
  gruposEconomicos = [];
  loading: boolean = false;
  somenteFab = [
    {nome: 'Sim', valor: 'true'},
    {nome: 'Não', valor: 'false'}
  ];

  constructor(private visaoLeadsServiceService: VisaoLeadsServiceService,
    private veiculosPropostas: FiltroService,
    private fb: FormBuilder) {
    this.filtrosDealers = new FiltroDealers(this.visaoLeadsServiceService);
    const regionaisPromise = this.visaoLeadsServiceService.buscarRegionais();
    Promise.all([regionaisPromise]).then(([regionais]) => {
      this.regionais = regionais;
    }).catch(error => {
      this.loading = false;
      console.error('Erro ao carregar dados iniciais:', error);
    }); 
    this.filtros = {};
    this.form = this.fb.group({
      data_inicial: [moment(this.dataInicial).format('DD-MM-YYYY')],
      data_final: [moment(this.dataFinal).format('DD-MM-YYYY')],
      dealers: [''],
      grupo_economico: [''],
      modelo_veic: [''],
      versao_veic: [''],
      nome_vendedor: [''],
      somente_fabrica: [''],
      id_regional: [''],
    });
  }

  ngOnInit() {
    this.startDados();
    this.filtrosDealers.carregar();
    this.tratarData();
    this.preencherGruposEconomicos();

  }

  private tratarData() {
    const dataInicio = new Date();
    const dataFim = new Date();

    let firstDay = new Date(dataInicio.getFullYear(), dataInicio.getMonth(), 1);

    this.dataInicial = firstDay;
    this.dataFinal = dataFim;
  }

  public onAdicionarDealerFiltro(dealer: DealerItem) {
    dealer.selecionado = true;
    const sel = [];

    this.incluirFiltroDealers(sel);
    this.filtros.dealers = sel;
  }

  private incluirFiltroDealers(filtros: any[]) {
    if (this.filtrosDealers.selecionados().length > 0) {
      const item = { 'chave': 'dealers', 'valor': [] };
      this.filtrosDealers.selecionados().forEach(element => {
        item.valor.push(element.id);
      });
      filtros.push(item);
    }
  }

  private preencherGruposEconomicos() {
    this.veiculosPropostas.buscar('grupo_economico')
      .then(r => { this.gruposEconomicos = r.filtros; });
  }

  public removerDealer(dealer: any) {
    dealer.selecionado = false;
    const index = this.filtros.dealers;
    if (index > -1) {
      this.filtros.dealers.splice(index, dealer);
      this.filtrosSelecionados();
    }
  }

  public selecionarDealer() {
    this.displayFiltrosDealers = true;
  }

  public limpaDataInicial() {
    const dataInicio = new Date();
    this.dataInicial = new Date(dataInicio.getUTCFullYear(), dataInicio.getMonth(), 1);
  }

  public limpaDataFinal() {
    const dataFim = new Date();
    this.dataFinal = new Date(dataFim.getFullYear(), dataFim.getMonth(), dataFim.getDate());
  }

  get f() {
    return this.form.controls;
  }

  public filtroAPI() {
    this.totalInsucesso = 0
    this.loading = true;
    this.displayFiltros = false;

    this.f.data_inicial.setValue(moment(this.dataInicial).format('DD-MM-YYYY'));
    this.f.data_final.setValue(moment(this.dataFinal).format('DD-MM-YYYY'));

    this.filtrosSelecionados();
    this.getAll();
  }

  private getAll() {

    this.visaoLeadsServiceService.getDados(this.f.data_inicial.value, this.f.data_final.value, this.f.dealers.value, this.f.grupo_economico.value, 
      this.f.modelo_veic.value, this.f.versao_veic.value, this.f.nome_vendedor.value, this.f.somente_fabrica.value, this.f.id_regional.value).subscribe(dados => {
        this.leadData = dados.dados[0];
      });

    this.visaoLeadsServiceService.getDadosInsucessos(this.f.data_inicial.value, this.f.data_final.value, this.f.dealers.value, this.f.grupo_economico.value, 
      this.f.modelo_veic.value, this.f.versao_veic.value, this.f.nome_vendedor.value, this.f.somente_fabrica.value, this.f.id_regional.value).subscribe(dados => {
        this.insucessoLeads = dados;

        dados.forEach(dados => {
          this.totalInsucesso += dados.valor;
        })
      });

    this.visaoLeadsServiceService.getFluxo(this.f.data_inicial.value, this.f.data_final.value, this.f.dealers.value,
      this.f.grupo_economico.value,
      this.f.modelo_veic.value, this.f.versao_veic.value, this.f.nome_vendedor.value, this.f.somente_fabrica.value, this.f.id_regional.value).subscribe(dados => {
        this.funilConversao = dados;
      })

    this.visaoLeadsServiceService.getMotivos(this.f.data_inicial.value, this.f.data_final.value, this.f.dealers.value,
      this.f.grupo_economico.value,
      this.f.modelo_veic.value, this.f.versao_veic.value, this.f.nome_vendedor.value, this.f.somente_fabrica.value, this.f.id_regional.value).subscribe(dados => {
        this.insucesso = dados;
      })

    this.visaoLeadsServiceService.getPrimeiroContato(this.f.data_inicial.value, this.f.data_final.value, this.f.dealers.value,
      this.f.grupo_economico.value,
      this.f.modelo_veic.value, this.f.versao_veic.value, this.f.nome_vendedor.value, this.f.somente_fabrica.value, this.f.id_regional.value).subscribe(dados => {
        this.primeiroContato = dados;
      })

    this.visaoLeadsServiceService.getClassificacao(this.f.data_inicial.value, this.f.data_final.value, this.f.dealers.value,
      this.f.grupo_economico.value, 
      this.f.modelo_veic.value, this.f.versao_veic.value, this.f.nome_vendedor.value, this.f.somente_fabrica.value, this.f.id_regional.value).subscribe(dados => {
        this.statusContatoAtivo = {
          labels: dados.labels,
          datasets: [
            {
              data: dados.data,
              backgroundColor: [
                '#ff0000',
                '#f28c8c',
                '#999999',
                '#444444',
                '#007bff'
              ],
              hoverBackgroundColor: [
                '#ff0000',
                '#f28c8c',
                '#999999',
                '#444444',
                '#007bff'
              ]
            }
          ],
          detalhes: dados.detalhes,
        };
      })
    this.loading = false;
  }

  private filtrosSelecionados() {
    const dealers = [];
    this.incluirFiltroDealers(dealers);
    this.filtros.dealers = dealers.map(r => r.valor);
    if (this.filtros.dealers.length != 0) {
      this.form.controls['dealers'].setValue(this.filtros.dealers[0]);
    } else {
      this.form.controls['dealers'].setValue('');
    }
  }

  public exibirFiltro() {
    this.displayFiltros = true;
  }

  public getListagemComFiltros() {
    return this.dataInicial
      || this.dataFinal
      || this.form.controls['grupo_economico'].value
      || this.form.controls['dealers'].value
      || this.form.controls['modelo_veic'].value
      || this.form.controls['versao_veic'].value
      || this.form.controls['nome_vendedor'].value
      || this.form.controls['somente_fabrica'].value
      || this.form.controls['id_regional'].value;
  }

  private startDados() {
    this.loading = true;
    setTimeout(() => {
      this.getAll();
    }, 2000);

  }

  public limparFiltros() {
    this.form.controls['grupo_economico'].setValue('');
    this.form.controls['modelo_veic'].setValue('');
    this.form.controls['versao_veic'].setValue('');
    this.form.controls['nome_vendedor'].setValue('');
    this.form.controls['somente_fabrica'].setValue('');
    this.form.controls['id_regional'].setValue('');
  }
}
